import { render, staticRenderFns } from "./UserProfileUpdatePassword.vue?vue&type=template&id=df05be46&"
import script from "./UserProfileUpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UserProfileUpdatePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports